import { FC, useEffect, useRef, useState } from "react";
import styles from "./verify.module.scss";
import { useMutation } from "react-query";
import { useNavigate, useSearchParams } from "react-router-dom";
import registratoionService from "../../../service/register/registration";
import MsgModal from "../../../componsnts/common/customModal/customModal";

const Verify: FC = () => {
  const [isMsgModalOpen, setIsMsgModalOpen] = useState(false);
  const [modalMessageOpen, setModalMessageOpen] = useState('');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const backWebUrl = process.env.REACT_APP_DA_CHAUNG_BACK_WEB_URL;

  const handleVerify = (code: string) => {
    if (!isLoading) { // 檢查是否正在加載
      const encodeCode = encodeURI(code).replace(/%20/g, '+');
      const verifyData = { EmailValidCode: encodeCode };
      accountVerify(verifyData);
    }
  };

  const mesModal = (msg: string) => {
    setIsMsgModalOpen(true)
    setModalMessageOpen(msg)
  }

  const closeModal = () => {
    setIsMsgModalOpen(false);
    handleRedirect();
  };

  // 在 useEffect 中調用
  useEffect(() => {
    const code = searchParams.get('code');
    if (code) {
      handleVerify(code);
    } else {
      console.log('no params');
      navigate('/home');
    }
  }, [searchParams]);

  const handleRedirect = () => {
    window.location.href = backWebUrl!;
  };


  const {
    mutate: accountVerify,
    isLoading,
    error,
  } = useMutation({
    mutationFn: (verifyData: any) => registratoionService.accountVerify(verifyData),
    onSuccess: (res) => {
      if (res.Success) {
        mesModal('您的信箱已完成驗證，可前往登入。')
      } else {
        mesModal('開通失敗，請洽技術人員')
      }
    },
    onError: (err) => {
      mesModal(`開通失敗: ${err}`)
    },
  });

  return (
    <div className={styles["verify_container"]}>
      <MsgModal isOpen={isMsgModalOpen} onClose={closeModal} message={modalMessageOpen}></MsgModal>
      <div className="verify_box">
        <div className="background_image"></div>
      </div>
    </div>
  );
};
export default Verify;
